import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

export const LanguageRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    // Get the current path segments
    const segments = location.pathname.split('/').filter(Boolean);
    
    // If we're at root or current path doesn't start with language code
    if (location.pathname === '/' || (segments[0] !== 'en' && segments[0] !== 'de')) {
      navigate(`/${language}`, { replace: true });
    }
  }, [navigate, language, location]);

  return null;
}; 